import React, { Component } from 'react'
import {Box,Paper,Grid2, Container, Typography,IconButton,Button, Checkbox,Divider, Tooltip} from '@mui/material'
import Appbar from './Appbar'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import mangalsutra from '../src/product_img/product1.png'
import RemoveIcon from '@mui/icons-material/Remove';
import tags from '../src/product_img/product1.png'
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import base_url from './base_url';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { ToastContainer, toast } from "react-toastify";





import { useNavigate,useLocation } from 'react-router-dom';
export class CartList extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       cartList : [],


       selectedForOrder : []

    }
  }



componentDidMount(){
  /// retrive cartList
this.retriveCartList();
}



retriveCartList=()=>{
  /// retrive wish list details
  let email = localStorage.getItem('email');
  if(email!==null){
  fetch(
    `${base_url.base_url}/cartList/retriveCartList`,
    {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body : JSON.stringify({
        email  : email
      })
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      this.setState({
       cartList : result.data
      },()=>{
        sessionStorage.setItem('cartListCount', result.data.length)
      });
    });

  }
}



removeItemFromCart=(product_id)=>{
  let email = localStorage.getItem('email');
  if(email!==null){
  fetch(
    `${base_url.base_url}/cartList/removeItemsInCart`,
    {
      headers: {
        "content-type": "application/json",
      },
      method: "delete",
      body : JSON.stringify({
        email  : email,
        product_id : product_id
      })
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((result) => {
    this.retriveCartList();
    this.removeFromcart();
    });

  }
}


removeFromcart = () => {
  toast.success("Removed from cartList ", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    // transition: Bounce,
  });
};


  render() {
    let selectedForOrder = this.state.cartList
    const sum = selectedForOrder.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (
      <div>
<Box sx={{backgroundColor:'#e9edee'}}>
<Appbar/>
<br/>
<br/>
<br/>

<Container maxWidth='xl'>

<Grid2 container spacing={2}>
<Grid2 item size={{xs:12,sm:9}}>
<Box>


<Paper variant='outlined' sx={{minHeight:60,width:'100%',display:'flex',justifyContent:'center',flexDirection:'column'}}>

<Typography sx={{fontSize:15,fontWeight:'600',color:'black',pl:2,textTransform:'uppercase'}}>YOUR CART PRODUCTS LIST</Typography>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black',pl:2}}>You have saved item below for buying products.</Typography>

</Paper>

<Box sx={{minHeight:400,width:'100%',mt:1,backgroundColor:'transparent'}}>
<Box sx={{p:0}}>
{
this.state.cartList.map((i)=>(
<Paper variant='outlined' sx={{minHeight:230,mt:0.5,mb:0.5,backgroundColor:'#fff'}} >
<Grid2 container spacing={3}>
<Grid2 item size={{xs:12,sm:3}}>
<Box sx={{width:'100%',display:'flex'}}>
<img src={`${base_url.base}` + "/" + `${i.thumb_nail_img}`} style={{height:250,width:'100%'}}/>
</Box>
</Grid2>
<Grid2 item size={{xs:12,sm:9}}>
<Box>
  <Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
     <Typography sx={{fontSize:17,textTransform:'capitalize',fontWeight:'500',color:'#106fca',mt:{xs:0,sm:1},p:1,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`}}>{i.product_name}</Typography>
  </Box>

<Typography sx={{fontSize:11,fontWeight:'600',color:'#09488b',textTransform:'uppercase',pl:1,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`}}>in stock</Typography>

<Box sx={{display:'flex',justifyContent:'left',mt:1,mb:1,pl:1}}>
<img src={tags} style={{height:20,width:83,objectFit:'fill'}}/>
</Box>

<Box sx={{display:'flex',justifyContent:'left',mt:0.5,mb:0.5,pl:1}}>
<Typography sx={{fontSize:15,fontWeight:'600',color:'#2c2c2c' , fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`}}>Price :   {(parseInt(i.price)).toLocaleString('en-US', {
                                   style: 'currency',
                                   currency: 'INR',
                                    })}/-</Typography>
</Box>

<Box sx={{display:'flex',justifyContent:'left',mt:1,mb:0.5,pl:1}}>
<Typography sx={{fontSize:12,display:'flex',flexDirection:'row',fontWeight:'600',color:'#1b7bce', fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`}}>Quantity :  <Typography sx={{fontSize:12,fontWeight:'600',color:'black',ml:1}}>{i.weight}</Typography></Typography>
</Box>



<Box sx={{display:'flex',flexDirection:'row'}}>
<Tooltip title='Remove from cart'>
<IconButton color="primary" aria-label="remove" size='small' sx={{backgroundColor:'#f2e4e5',ml:1,mt:2}} onClick={this.removeItemFromCart.bind(this,i.product_id)}>
  <DeleteOutlineIcon sx={{color:'#e62532',height:17,width:17}} />
</IconButton>
</Tooltip>

<Button variant='contained' size='small' sx={{ml:2,height:27,fontSize:11,mt:2}} onClick={()=>{this.props.navigate('/finalorders', {state: {data : [i]}})}}>Buy This</Button>
</Box>






</Box>
</Grid2>
</Grid2>

</Paper>
))
}
</Box>
</Box>


<Paper variant='outlined' sx={{minHeight:50,width:'100%',display:'flex',justifyContent:'space-between',flexDirection:'row',alignItems:'center',mt:1}}>
<Typography sx={{fontSize:15,fontWeight:'600',color:'black',pl:2,textTransform:'uppercase'}}>TOTAL COST :</Typography>
<Typography sx={{fontSize:17,fontWeight:'600',color:'black',pr:2}}>{(parseInt(sum)).toLocaleString('en-US', {
                                   style: 'currency',
                                   currency: 'INR',
                                    })}</Typography>
</Paper>




</Box>
</Grid2>
<Grid2 item size={{xs:12,sm:3}}>
<Box>
<Paper variant='outlined' sx={{minHeight:140,width:'100%'}}>


<Typography textAlign='center' sx={{fontSize:17,fontWeight:'600',mt:2,mb:1}}>Selected ({selectedForOrder.length} Items):</Typography>
<Divider/>
<Typography textAlign='center' sx={{fontSize:18,fontWeight:'600',mt:1,color:'#1b7bce'}}>Pay : {(parseInt(sum)).toLocaleString('en-US', {
                                   style: 'currency',
                                   currency: 'INR',
                                    })}</Typography>

<Box sx={{display:'flex',justifyContent:'center',alignItems:'center',mt:2}}>
  <Button onClick={()=>{
    if(this.state.selectedForOrder.length > 0){
      this.props.navigate('/finalorders', {state: {data : this.state.selectedForOrder}})
    }else{
      alert('No items selected')
    }
  }} variant='contained' disableElevation size='small' endIcon={<ArrowForwardIcon/>} sx={{height:25,p:2, textTransform:'none',width:'80%',backgroundColor:'#ab266c',mb:2}}>ORDER ALL NOW</Button>
</Box>






</Paper>
</Box>
</Grid2>

</Grid2>



</Container>
<br/>
</Box>



        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          //transition={Bounce}
        />
      </div>
    )
  }
}

export default CartList


export function CartListc(props){
  const navigate = useNavigate();
  const location = useLocation();
  return (<CartList navigate={navigate}></CartList>)
}
